import { Component, OnInit, AfterViewInit, Input ,
  DestroyRef,
  inject,
  ChangeDetectionStrategy,
  ChangeDetectorRef} from "@angular/core";
import { ListMentionsService } from "../../../../data/mention/list-mentions.service";
import { ActivatedRoute } from "@angular/router";
import { DatabaseCacheService } from "../../../../data/cache/database-cache.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { interval } from "rxjs";
import { SHARED_IMPORTS } from "src/app/shared/standalone-imports";
import { AppBadgeService } from "@app/core/state/app-badge.service";

// @Injectable({
//   providedIn: 'root'
// })
@Component({
  selector: "app-mention-menu-item",
  templateUrl: "./mention-menu-item.component.html",
  styleUrls: ["./mention-menu-item.component.css"],
  imports: SHARED_IMPORTS,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MentionMenuItemComponent implements OnInit, AfterViewInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly appBadge = inject(AppBadgeService);
  private readonly cdr = inject(ChangeDetectorRef);

  @Input() inner_div_class: string = "";

  static LOAD_MENTION_INTERVAL_MSEC = 60000;

  public hasUnreadMentions: boolean = false;
  public unreadCount: number = 0;

  _intervalId: any;  constructor(
    private listMentionsService: ListMentionsService,
    private databaseCashe: DatabaseCacheService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    this.appBadge.init();
    document.addEventListener("visibilitychange", this.handleVisibilityChange); // タブが切り替わったとき
    window.addEventListener("blur", () => {
      this.stopPolling();
    });
    window.addEventListener("focus", () => {
      this.startPolling(MentionMenuItemComponent.LOAD_MENTION_INTERVAL_MSEC);
    });
    this.listMentionsService.unreadExist$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isExist) => {
          this.hasUnreadMentions = isExist;
          this.cdr.markForCheck();
    });
    this.listMentionsService.unreadCount$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((count) => {
          this.unreadCount = count;
          this.cdr.markForCheck();
    });
    this.databaseCashe.parametersUpdated.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (data) => {
          // await this._checkUnreadMentions();
    });
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (params) => {
          // await this._checkUnreadMentions();
    });
  }

  ngOnDestroy() {
    if (this._intervalId) {
      clearInterval(this._intervalId);
    }
    }

  async ngAfterViewInit() {
    this.startPolling(MentionMenuItemComponent.LOAD_MENTION_INTERVAL_MSEC);

    // this._intervalId = setInterval(() => {
    //   this._checkUnreadMentions();
    // }, 30000);

    //
        //   interval(MentionMenuItemComponent.LOAD_MENTION_INTERVAL_MSEC).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
              //     this._checkUnreadMentions();
              //   })
              // );
              }

              async _checkUnreadMentions() {
              // Skip API request if contract is CLOSE
              const contractEnabled = this.databaseCashe.getSelectedSectionContractEnabled();
              if (contractEnabled === false) {
                this.hasUnreadMentions = false;
                this.unreadCount = 0;
                this.cdr.markForCheck();
                return;
              }

              try {
              await this.listMentionsService.isUnreadMentionsExist();
              } catch (error) {
              console.error(
              `[${MentionMenuItemComponent.name}] Failed to fetch mentions / error=${error}`,
              );
              this.hasUnreadMentions = false;
              this.unreadCount = 0;
              this.cdr.markForCheck();
              }
              }

              private handleVisibilityChange = () => {
              if (document.visibilityState === "visible") {
              this.startPolling(MentionMenuItemComponent.LOAD_MENTION_INTERVAL_MSEC); // タブが非アクティブになったのでポーリング開始
              } else {
              this.stopPolling(); // タブが非アクティブになったのでポーリング停止
              }
              };

              private startPolling(interval: number) {
              this._checkUnreadMentions();
              this._intervalId = setInterval(() => {
              this._checkUnreadMentions();
              }, interval);
              }

              private stopPolling() {
              clearInterval(this._intervalId);
              }
              }
